import HeaderBar from "../../../../components/header/headerBar";
import SelectFeild from "../../../../components/select/selectField";
import MainButton from "../../../../components/button/mainButton";
import Icon from "@mdi/react";
import { mdiPrinter } from "@mdi/js";
import { TextBox } from "../../../../components/textfield";
import { useState, useEffect } from "react";
import "../../../../assets/styles/components/select.scss";
import { useHistory, useParams } from "react-router-dom";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  TreeSelect,
  Input,
  Table,
  InputNumber,
} from "antd";
import moment from "moment";
import axios from "axios";

interface ParamsType {
  id: string;
}
const GiftVoucherEdit = () => {
  let [formEditGift] = Form.useForm();

  const [state, setState] = useState<any>({
    status: [],
  });

  const history = useHistory();
  const [CnId, setCnId] = useState<any>([]);
  const [custommer, setCustommer] = useState<any>([]);

  const { id } = useParams<ParamsType>();
  // const [customName, setCustomerName] = useState<string>("");
  // const [channel, setChannel] = useState<string>("");
  // const [typeGiftVoucher1, setTypeGiftVoucher1] = useState<string>("");
  // const [dateDeal, setDateDeal] = useState<string>("");
  // const [dateExpire, setDateExpire] = useState<string>("");
  // const [typeGiftVoucher2, setTypeGiftVoucher2] = useState<string>("");
  // const [typeProceDure, setTypeProceDure] = useState<string>("");
  // const [departMent, setDepartMent] = useState<string>("");
  // const [treatMent, setTreatMent] = useState<string>("");
  // const [valueGift, setValueGift] = useState<string>("");
  // const [givenBy, setGivenBy] = useState<string>("");
  // const [approver, setApprover] = useState<string>("");
  // const [detailGift, setDetailGift] = useState<string>("");
  const [giftVoucher, setGiftVoucher] = useState<any>([]);
  const [typeGiftVoucher, setTypeGiftVoucher] = useState<string>("");
  const [optGiftvoucher, setOptGiftVoucher] = useState<any>([]);
  const [treatement, setTreatement] = useState<any>([]);
  const [category, setCategory] = useState<any>([]);
  const [subCategory, setSubCategory] = useState<any>([]);
  const [treatmentTypeTree, setTreatmentTypeTree] = useState<any>([]);
  const { SHOW_PARENT } = TreeSelect;
  const [disable, setDisabled] = useState<boolean>(true);
  const [optMonth, setoptMonth] = useState<any>([]);
  const [nameGiven, setNameGiven] = useState<any>([]);
  const [nameApprove, setNameApprove] = useState<any>([]);
  const [isTreatments, getTreatments] = useState<any>([]);
  const [dataItemGift, setdataItemGift] = useState<any>([]);
  const [isgetStartDate, getStartDate] = useState<any>([]);

  const [isDisabled, setIsDisabled] = useState(false);

  const dateFormat = "DD-MM-YYYY";
  const saveFormat = "YYYY-MM-DD";

  const option = [
    { value: "GV", name: "GV" },
    { value: "GC", name: "GC" },
  ];

  const typevoucher = [
    { value: "branch1", name: "วงเงิน" },
    { value: "branch2", name: "Specific Treatment" },
  ];

  const couse = [
    { value: "branch1", name: "Aesthetic" },
    { value: "branch2", name: "Surgery" },
    { value: "branch3", name: "Wellness & Anti Aging" },
    { value: "branch4", name: "Pharmacy & Product" },
  ];

  const typecourse = [
    { value: "branch1", name: "Wellness Nurse IV" },
    { value: "branch2", name: "Specific Treatment" },
  ];
  const columsitem = [
    {
      title: "",
      width: "8%",
      align: "center" as const,
      render: (text: any, data: any, index: number) => index + 1,
    },
    {
      title: "Code",
      dataIndex: "code",
      width: "15%",
      render: (text: any, data: any, index: number) => text,
    },
    {
      title: "List",
      dataIndex: "name",
      render: (text: any, data: any, index: number) => text,
    },
    {
      title: "Price/Unit",
      dataIndex: "setprice",
      width: "18%",
      align: "center" as const,
      render: (text: any, data: any, index: number) => text,
      // numberWithCommas(text, 2),
    },
  ];

  const onChangeGiftvoucher = (type: any) => {
    // console.log("type", type);
  };
  const onchangeTypeGift = (type: any) => {};

  const onChangeTreatment = (idTreatment: any) => {};
  const onChangeTypeTree = (value: any) => {
    console.log("onChangeTypeTree", value);
  };

  const onChangeMonth = (type: any) => {
    // console.log("month", type);
    let setStartDate = moment(isgetStartDate)
      .utcOffset(0, true)
      .format(saveFormat);
    const startDate = setStartDate;
    console.log("startDate", startDate);

    formEditGift.setFieldsValue({
      renewdate: moment(startDate).add(type, "months"),
    });
  };
  const getDataEditGiftvoucher = () => {
    axios.get(`/gift-vouchers/${id}`).then((res) => {
      console.log("res");

      const dataEditGift = res?.data;

      console.log("dataEditGift", dataEditGift);

      formEditGift.setFieldsValue({
        customer: dataEditGift?.customer,
        giftVoucher: dataEditGift?.giftVoucher,
        giftVoucherType: dataEditGift?.giftVoucherType,
        detail: dataEditGift?.detail,
        credit: dataEditGift?.credit,
        productCategories: dataEditGift?.productCategories,
        productCategory: dataEditGift?.productCategory,
        treatment: dataEditGift?.treatment,
        productSubCategory: dataEditGift?.productSubCategory,
        treatments: dataEditGift?.treatments,
        startDate: moment(dataEditGift?.startDate)
          .utcOffset(0, true)
          .format(dateFormat),
        endDate: moment(dataEditGift?.endDate)
          .utcOffset(0, true)
          .format(dateFormat),
        quantityMonth: dataEditGift?.quantityMonth,
        givenBy: dataEditGift?.givenBy,
        approver: dataEditGift?.approver,
      });

      setTypeGiftVoucher(dataEditGift?.giftVoucherType);
      getCustommer(dataEditGift?.customer);
      getTreatment(dataEditGift?.treatments);
      getGivenName(dataEditGift?.givenBy);
      getApproveName(dataEditGift?.approver);
      getSubCategory(dataEditGift?.productSubCategory);
      getStartDate(dataEditGift.startDate);
    });
  };
  const getGiftVoucher = async () => {
    const option = [
      { value: "gv", name: "GV" },
      { value: "gc", name: "GC" },
    ];
    const optVoucher = [];
    for (let i = 0; i < option?.length; i++) {
      optVoucher.push(
        <Select.Option value={option[i]?.value} key={option[i]?.value}>
          {option[i]?.name}
        </Select.Option>
      );
    }
    setGiftVoucher(optVoucher);
  };
  const getAPIs = async () => {
    getDataEditGiftvoucher();
    getTypeGiftVoucher();
    getGiftVoucher();
    getMonth();
    getTreatmentGV();
    getCategoty();
  };

  const getTreatment = async (idSet: any) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/treatments?page=1&search=`)
      .then((res) => {
        const datas = res?.data?.data;
        const opttreatement = [];
        for (let i = 0; i < idSet?.length; i++) {
          console.log(idSet[i]);

          const setTreatments = datas.find((x: any) => x._id === idSet[i]);
          if (setTreatments) {
            const setPrice = {
              ...setTreatments,
              setprice: setTreatments?.price?.normal?.coursePriceLocal,
            };
            // console.log("treatment", setPrice);

            opttreatement.push(setPrice);
          }
        }
        console.log("=>>>>>", opttreatement);

        setdataItemGift(opttreatement);
      });
  };
  useEffect(() => {
    getAPIs();
  }, []);

  const onSave = async () => {
    // console.log("SAVE SUCCESS FULL!..............",value);
  };

  const getCn = async (id: any) => {
    axios.get(`/member-opd/${id}`).then((res) => {
      const datas = res?.data?.code;
      // console.log("datas", datas);
      setCnId(datas);
    });
  };

  const getCustommer = async (id: any) => {
    axios
      .get(
        `/member-opd?page=1&branch=all&startMonth=2022-03&endMonth=2022-05&filterBy=all&search=`
      )
      .then((res) => {
        const datas = res?.data?.data;

        const optCustomer = [];
        for (let i = 0; i < datas?.length; i++) {
          optCustomer.push(
            <Select.Option value={datas[i]?._id} key={datas[i]?._id}>
              {datas[i]?.name}
            </Select.Option>
          );
        }

        const setCN = datas.find((x: any) => x._id === id);
        if (setCN) {
          formEditGift.setFieldsValue({
            cn: setCN.code,
          });
        }

        setCustommer(optCustomer);
        getTreatmentTypeTree();
      });
  };
  const getGivenName = async (id: any) => {
    axios.get(`/users?page=1&branch=all&search=`).then((res) => {
      const datas = res?.data?.data;
      // console.log("datas personnel", datas);
      const optGivenName = [];
      for (let i = 0; i < datas?.length; i++) {
        optGivenName.push(
          <Select.Option value={datas[i]?._id} key={datas[i]?._id}>
            {datas[i]?.displayName}
          </Select.Option>
        );
      }
      setNameGiven(optGivenName);
    });
  };
  const getApproveName = (_id: any) => {
    axios.get(`/users?page=1&branch=all&search=`).then((res) => {
      const datas = res?.data?.data;
      // console.log("datas personnel", datas);
      const optApproveName = [];
      for (let i = 0; i < datas?.length; i++) {
        optApproveName.push(
          <Select.Option value={datas[i]?._id} key={datas[i]?._id}>
            {datas[i]?.displayName}
          </Select.Option>
        );
      }

      setNameApprove(optApproveName);
    });
  };
  const getTreatmentTypeTree = async () => {
    // console.log("treatment type tree");
    axios.get(`product-categories?page=`).then(async (res) => {
      const category = res?.data?.data;
      console.log("TreatmentTypeTree=>>>>>>>>>", category);

      const test = category.map((x: any, key: number) => ({
        ...x,
        value: x._id,
        title: x.name,
        // children: [
        //   {
        //     value: `sub2-${key}`,
        //     title: `test-sub2-${key}`,
        //     children: [{ value: `sub3-${key}`, title: `test-sub3-${key}` }],
        //   },
        // ],
      }));

      const children = [];
      for (let i = 0; i < test.length; i++) {
        children.push(
          <Select.Option key={test[i].value}>{test[i].title}</Select.Option>
        );
      }
      // setchildren(children);
      console.log("test =>", test);

      setTreatmentTypeTree(children);
    });
  };

  const getTypeGiftVoucher = async () => {
    const typevoucher = [
      { value: "limit", name: "วงเงิน/Credit Price" },
      { value: "specific_treatment", name: "เฉพาะหัตถการ/Specific Treatmentt" },
    ];
    const optTypeGift = [];
    for (let i = 0; i < typevoucher?.length; i++) {
      optTypeGift.push(
        <Select.Option
          value={typevoucher[i]?.value}
          key={typevoucher[i]?.value}
        >
          {typevoucher[i]?.name}
        </Select.Option>
      );
    }
    setOptGiftVoucher(optTypeGift);
  };
  const getMonth = () => {
    const option = [
      { value: "1", name: "1 เดือน/Month" },
      { value: "3", name: "3 เดือน/Month" },
      { value: "6", name: "6 เดือน/Month" },
      { value: "12", name: "12 เดือน/Month" },
    ];
    const month = [];

    for (let i = 0; i < option?.length; i++) {
      month.push(
        <Select.Option value={option[i]?.value} key={option[i]?.value}>
          {option[i]?.name}
        </Select.Option>
      );
    }
    setoptMonth(month);
  };
  const getCategoty = async () => {
    axios.get(`product-categories?page=`).then((res) => {
      const datas = res?.data?.data;
      // console.log("datas category", datas);
      const category = [];
      for (let i = 0; i < datas?.length; i++) {
        category.push(
          <Select.Option value={datas[i]?._id} key={datas[i]?._id}>
            {datas[i]?.name}
          </Select.Option>
        );
      }
      setCategory(category);
    });
  };
  const getSubCategory = async (_id?: any) => {
    console.log("_id", _id);

    // formCreateGift.setFieldsValue({ productSubCategory: "" });
    // axios.get(`/product-sub-categories/category/${_id}?page=1`).then((res) => {

    axios.get(`/product-sub-categories/?subCategoryId=${_id}`).then((res) => {
      const datas = res?.data?.data;
      console.log("datas sub", datas);

      const subcategory = [];
      for (let i = 0; i < datas?.length; i++) {
        subcategory.push(
          <Select.Option value={datas[i]?._id} key={datas[i]?._id}>
            {datas[i]?.name}
          </Select.Option>
        );
      }
      setSubCategory(subcategory);
    });
  };
  const getTreatmentGV = async () => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/treatments?page=1&search=`)
      .then((res) => {
        const datas = res?.data?.data;
        // console.log("treatment", datas);
        const opttreatement = [];
        for (let i = 0; i < datas?.length; i++) {
          opttreatement.push(
            <Select.Option value={datas[i]?._id} key={datas[i]?._id}>
              {datas[i]?.name}
            </Select.Option>
          );
        }
        setTreatement(opttreatement);
      });
  };
  const onsubmit = (value: any) => {
    console.log(value);
    try {
      let body = {
        quantityMonth: value.quantityMonthRenew,
        renew: moment(value.renewdate).utcOffset(0, true).format(saveFormat),
      };
      axios.patch(`/gift-vouchers/${id}`, body).then((res) => {
        console.log(res.data);
        history.push(`/setting/service/giftvoucher`);
      });
    } catch (error: any) {
      console.log("eror", error);
      return;
    }
  };
  return (
    <>
      <HeaderBar title="GIFT VOUCHER" btnBack={true} />
      <div style={{ padding: "10px 40px" }}>
        <div className="create-page">
          <h4>ต่ออายุบัตรกำนัล/ renew GIFT VOUCHER</h4>
          <Form form={formEditGift} onFinish={onsubmit}>
            <Row justify="space-between" style={{ marginTop: "20px" }}>
              <Col xs={24} sm={4} md={6} lg={6}>
                {/* <div className="heading">
                  <p>ชื่อลูกค้า/Customer</p>
                </div>
                <Form.Item
                  name="customer"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    onChange={(e: any) => {
                      getCn(e);
                    }}
                    style={{
                      width: "100%",
                      background: "#efefef",
                    }}
                    disabled={disable}
                  >
                    {custommer}
                  </Select>
                </Form.Item> */}
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                {/* <div className="heading">
                  <p>CN</p>
                </div>
                <Form.Item name="cn">
                  <Input
                    type="text"
                    disabled
                    style={{ background: "#efefef" }}
                    value={CnId}
                    placeholder={CnId}
                  />
                </Form.Item> */}
              </Col>
              <Col xs={24} sm={24} md={24} lg={24}>
                <div className="heading">
                  <p>Gift Voucher</p>
                </div>
                <Form.Item
                  name="giftVoucher"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    style={{ background: "#efefef", width: "100%" }}
                    onChange={(e: any) => onChangeGiftvoucher(e)}
                    showSearch
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={disable}
                  >
                    {giftVoucher}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row justify="space-between" style={{ marginTop: "20px" }}>
              <Col xs={24} sm={4} md={6} lg={6}>
                <div className="heading">
                  <p>ประเภท GIFT VOUCHER</p>
                </div>
                <Form.Item
                  name="giftVoucherType"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    style={{ background: "#efefef", width: "100%" }}
                    onChange={(e: any) => onchangeTypeGift(e)}
                    showSearch
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    defaultValue={typeGiftVoucher}
                    disabled={disable}
                  >
                    {optGiftvoucher}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                {typeGiftVoucher === "specific_treatment" && (
                  <>
                    <div className="heading">
                      <p>หัตถการ/Treatment </p>
                    </div>
                    <Form.Item
                      name="treatment"
                      rules={[
                        {
                          required: true,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <Select
                        disabled
                        style={{
                          width: "100%",
                          background: "#efefef",
                        }}
                        showSearch
                        filterOption={(input: any, option: any) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={(e: any) => {
                          onChangeTreatment(e);
                        }}
                      >
                        {treatement}
                      </Select>
                    </Form.Item>
                  </>
                )}
                {typeGiftVoucher === "limit" && (
                  <>
                    <div className="heading">
                      <p>มูลค่า/Price Credit</p>
                    </div>
                    <Form.Item
                      name="credit"
                      rules={[
                        {
                          required: true,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <InputNumber
                        controls={false}
                        type="number"
                        step="0.00"
                        style={{
                          height: "auto",
                          width: "100%",
                          border: "none",
                          borderRadius: "0px",
                          borderBottom: "2px solid #d9d9d9",
                          background: "#efefef",
                        }}
                        disabled={disable}
                      ></InputNumber>
                    </Form.Item>
                  </>
                )}
              </Col>

              <Col xs={24} sm={4} md={6} lg={6}>
                {typeGiftVoucher === "specific_treatment" && (
                  <>
                    <div className="heading">
                      <p>ประเภทหัตถการ/Treatment Type</p>
                    </div>
                    <Form.Item
                      name="productCategory"
                      rules={[
                        {
                          required: true,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <Select
                        style={{ width: "100%", background: "#efefef" }}
                        onChange={(e) => {
                          // getSubCategory(e);
                        }}
                        showSearch
                        filterOption={(input: any, option: any) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        disabled={true}
                      >
                        {category}
                      </Select>
                    </Form.Item>
                  </>
                )}

                {typeGiftVoucher === "limit" && (
                  <>
                    <div className="heading">
                      <p>รายละเอียด/Details</p>
                    </div>
                    <Form.Item
                      name="detail"
                      rules={[
                        {
                          required: true,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <Input
                        style={{ width: "100%", background: "#efefef" }}
                        disabled={disable}
                      ></Input>
                    </Form.Item>
                  </>
                )}
              </Col>
            </Row>
            {typeGiftVoucher === "specific_treatment" ? (
              <Row justify="space-between" style={{ marginTop: "20px" }}>
                <Col xs={24} sm={4} md={6} lg={6}>
                  <div className="heading">
                    <p>แผนกหัตถการ/Treatment Department</p>
                  </div>
                  <Form.Item
                    name="productSubCategory"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Select
                      style={{
                        width: "100%",
                        background: "#efefef",
                      }}
                      showSearch
                      filterOption={(input: any, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      disabled={disable}
                    >
                      {subCategory}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={4} md={6} lg={6}>
                  <div className="heading">
                    <p>มูลค่า/Price Credit</p>
                  </div>
                  <Form.Item
                    name="credit"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <InputNumber
                      controls={false}
                      type="number"
                      step="0.00"
                      style={{
                        height: "auto",
                        width: "100%",
                        border: "none",
                        borderRadius: "0px",
                        borderBottom: "2px solid #d9d9d9",
                      }}
                      disabled
                    ></InputNumber>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={4} md={6} lg={6}>
                  <div className="heading">
                    <p>รายละเอียด/Details</p>
                  </div>
                  <Form.Item
                    name="detail"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Input disabled></Input>
                  </Form.Item>
                </Col>
              </Row>
            ) : (
              <Row justify="space-between" style={{ marginTop: "20px" }}>
                <div className="heading">
                  <p>ประเภทหัตถการ/Treatment Type</p>
                </div>
                <Col xs={24} sm={24} md={24} lg={24}>
                  {console.log("Treatment type", treatmentTypeTree)}
                  <Form.Item name="productCategories">
                    <Select
                      mode="multiple"
                      allowClear
                      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                      style={{ width: "100%" }}
                      placeholder="เลือกประเภทหัตถการ"
                      onChange={onChangeTypeTree}
                      disabled={disable}
                    >
                      {treatmentTypeTree}
                    </Select>
                  </Form.Item>
                </Col>

                <div>
                  <Col
                    xs={24}
                    sm={24}
                    md={16}
                    lg={16}
                    style={{ marginTop: "20px" }}
                  >
                    <div className="heading">
                      <h5>
                        รายการสำหรับบัตรกำนัลนี้นี้/Items For This Gift Voucher.
                      </h5>
                    </div>
                  </Col>

                  <Table
                    style={{ marginTop: "10px" }}
                    bordered
                    columns={columsitem}
                    dataSource={dataItemGift}
                    scroll={{ y: 561 }}
                    pagination={false}
                  ></Table>
                </div>
              </Row>
            )}
            <Row justify="space-between" style={{ marginTop: "20px" }}>
              <Col xs={24} sm={4} md={6} lg={6}>
                <div className="heading">
                  <p>วันที่ออก/Date Start</p>
                </div>
                <Form.Item
                  name="startDate"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  {/* <DatePicker
                    placeholder="เลือกวันที่ออก"
                    format={dateFormat}
                    style={{
                      height: "auto",
                      width: "100%",
                      border: "none",
                      borderRadius: "0px",
                      borderBottom: "2px solid #d9d9d9",
                    }}
                    disabled={disable}
                  /> */}
                  <Input
                    type="text"
                    disabled
                    style={{
                      height: "auto",
                      width: "100%",
                      border: "none",
                      borderRadius: "0px",
                      borderBottom: "2px solid #d9d9d9",
                    }}
                    placeholder="เลือกวันที่ออก"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <div className="heading">
                  <p>จำนวนเดือน/ Quantity Month</p>
                </div>
                <Form.Item
                  name="quantityMonth"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%", background: "#efefef" }}
                    // onChange={(e: any) => onChangeMonth(e)}
                    disabled={disable}
                  >
                    {optMonth}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <div className="heading">
                  <p>วันหมดอายุ/Date End</p>
                </div>
                <Form.Item
                  name="endDate"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  {/* <DatePicker
                    format={dateFormat}
                    placeholder="เลือกวันหมดอายุ"
                    style={{
                      height: "auto",
                      width: "100%",
                      border: "none",
                      borderRadius: "0px",
                      borderBottom: "2px solid #d9d9d9",
                    }}
                    disabled={disable}
                  ></DatePicker> */}
                  <Input
                    type="text"
                    disabled
                    style={{
                      height: "auto",
                      width: "100%",
                      border: "none",
                      borderRadius: "0px",
                      borderBottom: "2px solid #d9d9d9",
                    }}
                    placeholder="เลือกวันที่ออก"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row justify="space-between" style={{ marginTop: "20px" }}>
              <Col xs={24} sm={4} md={6} lg={6}>
                {/* <div className="heading">
                  <p>จำนวนที่ออกในครั้งนี้/Quantity</p>
                </div>
                <Form.Item
                  name="amount"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    style={{
                      height: "auto",
                      width: "100%",
                      border: "none",
                      borderRadius: "0px",
                      borderBottom: "2px solid #d9d9d9",
                    }}
                  />
                </Form.Item> */}
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <div className="heading">
                  <p>มอบโดย/Given By</p>
                </div>
                <Form.Item
                  name="givenBy"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%", background: "#efefef" }}
                    onChange={(e: any) => getApproveName(e)}
                    disabled={disable}
                  >
                    {nameGiven}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <div className="heading">
                  <p>ผู้อนุมัติ/Approver By</p>
                </div>
                <Form.Item
                  name="approver"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%", background: "#efefef" }}
                    disabled={disable}
                  >
                    {nameApprove}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row justify="space-between" style={{ marginTop: "20px" }}>
              <Col xs={24} sm={4} md={6} lg={6} />
              <Col xs={24} sm={4} md={6} lg={6}>
                <div className="heading">
                  <p>จำนวนเดือน/ Quantity Month</p>
                </div>
                <Form.Item
                  name="quantityMonthRenew"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%" }}
                    onChange={(e: any) => onChangeMonth(e)}

                    // onChange={(e: any) => getApproveName(e)}
                  >
                    {optMonth}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                {/* <Button
                  htmlType="submit"
                  style={{
                    width: "100%",
                    height: 50,
                    background: "#4D7E7F",
                    borderRadius: 4,
                    color: "white",
                  }}
                >
                  สร้าง / CREATE
                </Button> */}
                <div className="heading">
                  <p>ต่ออายุถึงวันที่/Renew to Date</p>
                </div>
                <Form.Item
                  name="renewdate"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <DatePicker
                    placeholder="เลือกวันที่ต่ออายุถึง"
                    format={dateFormat}
                    style={{
                      height: "auto",
                      width: "100%",
                      border: "none",
                      borderRadius: "0px",
                      borderBottom: "2px solid #d9d9d9",
                    }}
                  ></DatePicker>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
        <div className="justify-center mt-20">
          <MainButton
            className="mg-10"
            background="#E76464"
            title="ยกเลิก/Cancel"
            onClick={() => {
              // handleCancel();
              history.push(`/setting/service/giftvoucher`);
            }}
          />
          {/* <MainButton
            className="mg-10"
            background="#4285F4"
            title="พิมพ์/Print"
            onClick={() => history.push(`giftvoucherprint`)}
          >
            <Icon path={mdiPrinter} size="20" color="#ffff" />
          </MainButton> */}
          <MainButton
            className="mg-10"
            onClick={() => {
              // handleCancel();

              console.log("submit...");
              formEditGift.submit();
            }}
            title="บันทึก/Save"
          />
        </div>
      </div>
    </>
  );
};
export default GiftVoucherEdit;
